import ABCyaPhaser from "@abcya/abcya_phaser";
import gameData from "../gameData";

export default class Gem extends Phaser.GameObjects.Container
{
    constructor(scene, p, i, n, e)
    {
        super(scene);
        p.add(this);

        this.scene = scene;
        this.pCont = p;
        this.ind = i;
        this.randInd = n;
        this.isEnd = e;
        this.isSelected = false;
        this.adj = 0;
        this.breakType = "gem" + this.ind + "Ex";
		
        this.createGem();
    }

	createGem() {
        this.glitterC = this.scene.add.container();

        this.glitterB = ABCyaPhaser.Images.addImage(Phaser.Math.Between(-30, 30), Phaser.Math.Between(-30, 30), "SparkleLarge", this.glitterC);
        this.glitterS = ABCyaPhaser.Images.addImage(Phaser.Math.Between(-30, 30), Phaser.Math.Between(-30, 30), "SparkleSmall", this.glitterC);

        if(this.ind < 15){
            this.body = ABCyaPhaser.Images.addImage(0, 0, "Gem"+String(this.ind), this);

            if(!this.isEnd){
                this.explosion = this.scene.add.sprite(0, 0).play(this.breakType);
                // this.add(this.fire);

                if(this.ind == 1){
                    this.explosion.x = -225;
                    this.explosion.y = -165;
                }
                if(this.ind == 2){
                    this.explosion.x = -180;
                    this.explosion.y = -163;
                }
                if(this.ind == 3){
                    this.explosion.x = -220;
                    this.explosion.y = -210;
                }
                if(this.ind == 4){
                    this.explosion.x = -257;
                    this.explosion.y = -200;
                }
                if(this.ind == 5){
                    this.explosion.x = -190;
                    this.explosion.y = -158;
                }
                if(this.ind == 6){
                    this.explosion.x = -202;
                    this.explosion.y = -163;
                }
                if(this.ind == 7){
                    this.explosion.x = -195;
                    this.explosion.y = -128;
                }
                if(this.ind == 8){
                    this.explosion.x = -197;
                    this.explosion.y = -118;
                }
                if(this.ind == 9){
                    this.explosion.x = -195;
                    this.explosion.y = -146;
                }
                if(this.ind == 10){
                    this.explosion.x = -187;
                    this.explosion.y = -128;
                }
                if(this.ind == 11){
                    this.explosion.x = -220;
                    this.explosion.y = -110;
                }
                if(this.ind == 12){
                    this.explosion.x = -212;
                    this.explosion.y = -150;
                }
            }

            this.glitter("inB");
            this.glitter("inS");
        } else {
            if(this.ind == 98){
                this.body = ABCyaPhaser.Images.addImage(0, 0, "Bomb", this);
                this.cloud1 = ABCyaPhaser.Images.addImage(0, 0, "cloud1", this);
                this.cloud2 = ABCyaPhaser.Images.addImage(0, 0, "cloud2", this);
            }
            if(this.ind == 99){
                this.body = ABCyaPhaser.Images.addImage(0, 0, "Stopwatch", this);
            }
            this.pulse("pulse");
        }

        this.add(this.glitterC);
	};

    changeSpecial(type){
        if(this.scene == null) return; // prevent issues in case this gem was destroyed
        
        // console.log("CREATING SPECIAL!");
        this.stopMovement();

        if(this.body){
            this.body.destroy();
            this.body = null;
        }
        
        this.ind = type;

        if(type < 15){
            this.glitterC.removeAll(true);
            this.glitterC.destroy();
            this.glitterC = null;
            this.glitterC = this.scene.add.container();

            this.glitterB = ABCyaPhaser.Images.addImage(Phaser.Math.Between(-30, 30), Phaser.Math.Between(-30, 30), "SparkleLarge", this.glitterC);
            this.glitterS = ABCyaPhaser.Images.addImage(Phaser.Math.Between(-30, 30), Phaser.Math.Between(-30, 30), "SparkleSmall", this.glitterC);

            this.body = ABCyaPhaser.Images.addImage(0, 0, "Gem"+String(this.ind), this);
            this.add(this.glitterC);

            this.glitter("inB");
            this.glitter("inS");
        }

        if(type > 90){
            if(type == 97){
                this.body = ABCyaPhaser.Images.addImage(0, 0, "Dynamite", this);
            }
            if(type == 98){
                this.body = ABCyaPhaser.Images.addImage(0, 0, "Bomb", this);
            }
            if(type == 99){
                this.body = ABCyaPhaser.Images.addImage(0, 0, "Stopwatch", this);
            }

            this.glitterB.x = 0;
            this.glitterS.x = 0;
            this.glitterB.y = 0;
            this.glitterS.y = 0;

            this.glitter("rotB", 0, 0);

            this.body.setScale(2);
            this.moveTo(this.body, this.list.length-1);

            ABCyaPhaser.Tweens.addTween(this.body, 1000, {scale:1}, Phaser.Math.Easing.Bounce.Out, ()=>{
                this.scene.gemArea.setUI(true);
                this.pulse();
            });
        }
    };

    pulse(){
        ABCyaPhaser.Tweens.addTween(this.body, 1000, {scale:1.15, yoyo:true, repeat:-1}, Phaser.Math.Easing.Linear);
    };

    glitter(type, stAmt, stAmt2){
        // console.log(this.glitterB.scene)
        let randBWait;
        let randSWait;
        let randBRot;
        let startAmountB = stAmt;
        let startAmountS = stAmt2;

        if(type == "inB"){
            if(!this.glitterB.scene) return;

            randBWait = Phaser.Math.Between(1000, 10000);

            this.glitterB.x = Phaser.Math.Between(-30, 30);
            this.glitterB.y = Phaser.Math.Between(-30, 30);
            this.glitterB.alpha = 0;

            this.glitterBTween = this.scene.tweens.timeline({
                targets: this.glitterB,
                ease:Phaser.Math.Easing.Linear,
                loop:-1,
                loopDelay:Phaser.Math.Between(1000, 10000),

                tweens: [
                    {delay:randBWait, alpha:1, duration: 500},
                    {alpha:Phaser.Math.FloatBetween(.1, .5), duration: Phaser.Math.Between(500, 1000)},
                    {alpha:Phaser.Math.FloatBetween(.5, 1), duration: Phaser.Math.Between(500, 1000)},
                    {alpha:0, duration: 500},
                ]
            });
        }
        if(type == "inS"){
            if(!this.glitterS.scene) return;

            randSWait = Phaser.Math.Between(1000, 10000);
            let randGSx = Phaser.Math.Between(-30, 30);
            let randGSy = Phaser.Math.Between(-30, 30);

            this.glitterS.y = randGSx;
            this.glitterS.y = randGSy;
            this.glitterS.alpha = 0;

            this.glitterSTween = this.scene.tweens.timeline({
                targets: this.glitterS,
                ease:Phaser.Math.Easing.Linear,
                loop:-1,
                loopDelay:Phaser.Math.Between(1000, 10000),

                tweens: [
                    {delay:randSWait, alpha:1, duration: 500},
                    {alpha:Phaser.Math.FloatBetween(.1, .5), duration: Phaser.Math.Between(500, 1000)},
                    {alpha:Phaser.Math.FloatBetween(.5, 1), duration: Phaser.Math.Between(500, 1000)},
                    {alpha:0, duration: 500},
                ]
            });
        }
        if(type == "rotB"){
            if(!this.glitterS.scene || !this.glitterB.scene) return;

            //console.log("ROTING!");
            this.glitterC.visible = true;

            randBRot = Phaser.Math.Between(180, 360);

            this.glitterB.angle = startAmountB;
            this.glitterS.angle = startAmountS;
            this.glitterB.alpha = 1;
            this.glitterS.alpha = 0;
            this.glitterC.scaleX = this.glitterC.scaleY = 4;
            this.glitterS.scaleX = this.glitterS.scaleY = 1.75;

            this.glitterSTween = ABCyaPhaser.Tweens.addTween(this.glitterS, 2000, {alpha:1, angle:randBRot}, Phaser.Math.Easing.Linear);
            this.glitterBTween = ABCyaPhaser.Tweens.addTween(this.glitterB, 2000, {alpha:0, angle:-randBRot}, Phaser.Math.Easing.Linear, ()=>{
                this.glitter("rotS", randBRot, -randBRot);
            });
        }
        if(type == "rotS"){
            if(!this.glitterS.scene || !this.glitterB.scene) return;

            randBRot = Phaser.Math.Between(180, 360);

            this.glitterB.angle = startAmountB;
            this.glitterS.angle = startAmountS;
            this.glitterB.alpha = 0;
            this.glitterS.alpha = 1;
            this.glitterC.scaleX = this.glitterC.scaleY = 4;
            this.glitterS.scaleX = this.glitterS.scaleY = 1.75;

            this.glitterSTween = ABCyaPhaser.Tweens.addTween(this.glitterS, 2000, {alpha:0, angle:-randBRot}, Phaser.Math.Easing.Linear);
            this.glitterBTween = ABCyaPhaser.Tweens.addTween(this.glitterB, 2000, {alpha:1, angle:randBRot}, Phaser.Math.Easing.Linear, ()=>{
                this.glitter("rotB", randBRot, -randBRot);
            });
        }
    };

    explode(isBomb){
        if(!this.body) return;
        
        let explodeTimer;

        if(isBomb){
            // console.log("bomb exploding");
            const rand1Rot = Phaser.Math.Between(-180, 180);
            const rand2Rot = Phaser.Math.Between(-180, 180);

            explodeTimer = 500;

            this.cloud1 = ABCyaPhaser.Images.addImage(0, 0, "cloud1", this);
            this.cloud2 = ABCyaPhaser.Images.addImage(0, 0, "cloud2", this);

            this.cloud1.angle = Phaser.Math.Between(-180, 360);
            this.cloud2.angle = Phaser.Math.Between(-180, 360);
            this.cloud1.scaleX = this.cloud1.scaleY = 0;
            this.cloud2.scaleX = this.cloud2.scaleY = 0;

            ABCyaPhaser.Tweens.addTween(this.cloud1, 500, {alpha:0, scale:3, angle:rand1Rot}, Phaser.Math.Easing.Linear);
            ABCyaPhaser.Tweens.addTween(this.cloud2, 500, {alpha:0, scale:3, angle:rand2Rot}, Phaser.Math.Easing.Linear);
        } else {
            explodeTimer = 300;
        }

        this.stopMovement();
        this.body.destroy();
        this.glitterC.removeAll(true);
        this.glitterC.destroy();

        this.explosion = this.scene.add.sprite(0, 0).play(this.breakType);
        this.add(this.explosion);

        ABCyaPhaser.Tweens.addTween(this, explodeTimer, {scale:2, angle:Phaser.Math.Between(-180, 180)}, Phaser.Math.Easing.Linear, ()=>{
            this.destroyGem();
        });
    };

    stopMovement(){
        if(!this.scene) return;
        //stop the creatures tweens
        this.glitterBTween?.stop();
        this.glitterSTween?.stop();
        
        if(this.body) this.scene.tweens.killTweensOf(this.body);
        if(this.glitterB) this.scene.tweens.killTweensOf(this.glitterB);
        if(this.glitterS) this.scene.tweens.killTweensOf(this.glitterS);
    };

    destroyGem (){
        //Destroy the gem
        //console.log("DESTROYING");
        this.stopMovement();

        this.removeAll(true);

        this.destroy();
    };
}